const D = document
const A = 'active'


const addClass = function (C) {
  this.classList.add(C)
}

const removeClass = function (C) {
  this.classList.remove(C)
}

let active = function () {
  let th = this
  let tissueNavs = (th.tissue && th.tissue.tissueNavs) || null
  let tissueItems = (th.tissue && th.tissue.tissueItems) || null
  if(!tissueNavs){
    return false
  }

  tissueNavs.forEach(function (value) {
    if(value === th){
      addClass.call(value, A)
    }else{
      removeClass.call(value, A)
    }
  })

  let id = th.getAttribute('data-nav')

  if(tissueItems && id !== undefined){
    tissueItems.forEach(function (value) {
      if(value.getAttribute('data-nav') === id){
        addClass.call(value, A)
      }else{
        removeClass.call(value, A)
      }
    })
  }
};

export default function () {
  D.querySelectorAll('.js-tissue').forEach(function (tissue) {
    let tissueNavs = tissue.querySelectorAll('.js-tissue-nav');
    let tissueItems = tissue.querySelectorAll('.js-tissue-item');
    tissueNavs.forEach(function (tissueNav) {
      tissueNav.tissue = tissue
      on(tissueNav, 'click', active)
      on(tissueNav, 'mouseenter', active)
    })
    tissue.tissueNavs = tissueNavs
    tissue.tissueItems = tissueItems
  })
}
